// CANLI OPERASYON DURUMU — goz / demlik durum tablolari.
// Kaynak: Okkali-Kahve-Kurumsal hooks/useCupStatus.ts ve hooks/usePotStatus.ts
// (mobil uygulamanin birebir mantigi). Farklar:
//  - renkler hex degil `tone` anahtari (bilesen Tailwind sinifina cevirir)
//  - animasyonlar acik tema dosyalari (panel acik tema)
//  - göz etiketleri mobilden değil MAKİNEDEN (mobilde 4 "Kahve Pişiyor"
//    gibi yanlışlar vardı); yeni tablet metni kendisi gönderir (display)

import cleaning from "../../../../Assets/lottie/deviceStatus/white-cleaning.json";
import dirtyPot from "../../../../Assets/lottie/deviceStatus/dirtypot.json";
import moveDown from "../../../../Assets/lottie/deviceStatus/move-down.json";
import turkishCoffee from "../../../../Assets/lottie/deviceStatus/turkishcoffee-white.json";
import waterfill from "../../../../Assets/lottie/deviceStatus/turkishcoffee-waterfill-white.json";
import coffeeReady from "../../../../Assets/lottie/deviceStatus/white-turkishcoffeeready.json";
import pleaseWait from "../../../../Assets/lottie/deviceStatus/white-pleasewait.json";
import clockWaiting from "../../../../Assets/lottie/deviceStatus/clock-waiting-white.json";
import streakFire from "../../../../Assets/lottie/deviceStatus/streak-fire.json";
import waterWave from "../../../../Assets/lottie/deviceStatus/water-wave.json";
import teaBrew from "../../../../Assets/lottie/white-teabrew.json";
import filterCoffeeBrew from "../../../../Assets/lottie/filtrekahve-brew-white.json";

export const LOTTIE = {
  cleaning,
  dirtyPot,
  moveDown,
  turkishCoffee,
  waterfill,
  coffeeReady,
  pleaseWait,
  clockWaiting,
  streakFire,
  waterWave,
  teaBrew,
  filterCoffeeBrew,
};

// tone -> anlam: danger (kirmizi), water (camgobegi), ok (yesil),
// busy (turuncu), down (mor), wait (sari), heat (koyu turuncu), idle (gri)

// Etiketler MAKİNEDEKİYLE AYNI (tablet StatusDisplay çevirileri). Yeni tablet
// metni `display.text` ile zaten gönderir; bu tablo eski tablet sürümleri
// için yedektir.
const CUP_STATUS = {
  [-1]: { label: "Kotanız tükenmiştir", tone: "danger", icon: "quota" },
  [-2]: { label: "Temizlik Başlat", tone: "danger", lottie: "dirtyPot" },
  [-3]: { label: "Temizlik İçin Fincanı Koyun", tone: "danger", lottie: "dirtyPot" },
  0: { label: "Hazır", tone: "idle", icon: "check" },
  1: { label: "Pişirme İşlemi başlıyor", tone: "idle", icon: "check" },
  2: { label: "Pişirici İniyor", tone: "busy", lottie: "moveDown" },
  3: { label: "Pişiyor", tone: "busy", lottie: "turkishCoffee", showHeat: true },
  4: { label: "Su Alınıyor", tone: "busy", lottie: "waterfill" },
  5: { label: "Kahveniz Hazır", tone: "ok", lottie: "coffeeReady" },
  11: { label: "Pişirici Algılanamadı", tone: "danger", lottie: "dirtyPot" },
  12: { label: "Su Deposu Boş", tone: "danger", icon: "noWater" },
  13: { label: "Fincanda Su Yok", tone: "danger", lottie: "dirtyPot" },
  14: { label: "Fincanda Su Var", tone: "danger", lottie: "dirtyPot" },
  15: { label: "Fincan Yok", tone: "danger", lottie: "dirtyPot" },
  16: { label: "Isıtıcı Isıtmıyor", tone: "danger", lottie: "dirtyPot" },
  17: { label: "İptal Ediliyor", tone: "busy", lottie: "pleaseWait" },
  18: { label: "Fincanı Kaldırın", tone: "danger", lottie: "dirtyPot" },
  19: { label: "Lütfen Bekleyin", tone: "ok", lottie: "pleaseWait" },
  20: { label: "Su Gelmiyor", tone: "danger", icon: "noWater" },
  21: { label: "Pişirici Aşağıda", tone: "water", lottie: "moveDown" },
  30: { label: "Fincanı Koyun", tone: "water", lottie: "cleaning" },
  31: { label: "Temizlik Başlıyor", tone: "water", lottie: "cleaning" },
  32: { label: "Temizleniyor", tone: "water", lottie: "cleaning", showHeat: true },
  33: { label: "Temizlik Bitti", tone: "ok", lottie: "cleaning" },
  34: { label: "Temizleniyor", tone: "water", lottie: "cleaning" },
  40: { label: "Depo Doluyor", tone: "water", lottie: "waterfill" },
};

/** Türk kahvesi gözü: brewingStatus -> { label, tone, lottie?, icon?, showHeat? } */
export const getCupStatus = (brewingStatus) =>
  CUP_STATUS[brewingStatus] || {
    label: `Durum ${brewingStatus ?? "—"}`,
    tone: "idle",
  };

/** Çay / filtre kahve demliği — mobil getPotStatus ile aynı sıra. */
export const getPotStatus = (pot, lowWater, potProgramInfo, potKey) => {
  const b = pot?.brewInfo || {};
  const program = pot?.brewProgram;
  let hasProgram = false;
  if (potProgramInfo && potKey) {
    if (Array.isArray(potProgramInfo)) hasProgram = potProgramInfo.length > 0;
    else if (typeof potProgramInfo === "object" && potProgramInfo[potKey]) {
      const p = potProgramInfo[potKey];
      hasProgram = Array.isArray(p) ? p.length > 0 : !!p && typeof p === "object";
    }
  }
  const isCleaning = !!(b.cleaning || (b.mustCleanStep && b.mustCleanStep > 0));
  const type = String(b.type || "").toUpperCase();
  const isTea = type.includes("TEA");
  const isFilter = type.includes("FILTER") || (type.includes("COFFEE") && !isTea);
  const brewLottie = isFilter ? "filterCoffeeBrew" : "teaBrew";

  let s;
  if (b.loadingBrewing === 0 && !isCleaning) {
    s = lowWater
      ? { label: "Su Kazanı Doluyor", tone: "water", lottie: "waterWave" }
      : { label: "Su Kaynatılıyor", tone: "heat", lottie: "streakFire" };
  } else if (b.loadingBrewing >= 1 && !isCleaning) {
    if (isTea && b.loadingBrewing === 1) {
      s = { label: "Su Alınıyor", tone: "water", lottie: "waterWave" };
    } else {
      s = { label: "Demleniyor", tone: "busy", lottie: brewLottie };
    }
  } else if (b.dirtyPot && b.stalePot && !isCleaning && b.remain !== 0) {
    s = { label: "Bayat", tone: "busy", icon: isFilter ? "coffee" : "tea" };
  } else if (b.remain !== 0 && b.loadingBrewing !== 0 && b.dirtyPot && !isCleaning) {
    s = { label: "Taze", tone: "ok", icon: isFilter ? "coffee" : "tea" };
  } else if (b.dirtyPot && !b.cleaning && b.remain === 0 && !isCleaning) {
    s = { label: "Demliği Temizleyin", tone: "danger", lottie: "dirtyPot" };
  } else if (b.cleaning) {
    s = { label: "Temizlik Yapılıyor", tone: "water", lottie: "cleaning" };
  } else if (b.mustCleanStep === 1) {
    s = { label: "Kovan Temizleniyor", tone: "water", lottie: "cleaning" };
  } else if (b.mustCleanStep === 2) {
    s = { label: "Temizlik Malzemesi Koyuluyor", tone: "water", lottie: "cleaning" };
  } else if (b.mustCleanStep === 3) {
    s = { label: "Temizlik Suyu Alınıyor", tone: "water", lottie: "waterWave" };
  } else if (b.mustCleanStep === 4) {
    s = { label: "Temizlik Süresi Bekleniyor", tone: "water", lottie: "clockWaiting" };
  } else if (b.mustCleanStep === 5) {
    s = { label: "Demlik Durulanıyor", tone: "water", lottie: "waterWave" };
  } else if (
    ((program?.program && program.program !== "-" && program?.brewHour !== "-") ||
      hasProgram) &&
    !b.dirtyPot &&
    !isCleaning
  ) {
    s = { label: "Programlı Demlik", tone: "wait", lottie: "clockWaiting" };
  } else if (!b.dirtyPot && !isCleaning) {
    s = { label: "Demlik Temiz", tone: "idle", icon: "check" };
  } else {
    s = { label: "—", tone: "idle" };
  }

  const remain =
    b.remain && b.remain !== 0 && !isCleaning
      ? `${b.remain || 0}/${(b.drink || 0) + (b.remain || 0)}`
      : "";
  return { ...s, remain, productType: isTea ? "Çay" : isFilter ? "Filtre Kahve" : "" };
};

/** Demlik program / bitiş bilgisi — mobil getPotProgramStatus. */
export const getPotProgramStatus = (pot) => {
  const b = pot?.brewInfo;
  const program = pot?.brewProgram;
  if (!b) return null;
  if (b.loadingBrewing !== -1 && b.startDate) {
    const start = new Date(b.startDate).getTime();
    const finish = start + ((b.loadingBrewingTime || 0) + (b.loadingBrewingWaterTime || 0)) * 1000;
    return {
      kind: "countdown",
      info: b.type === "TEA" ? "Çay hazır olmasına kalan" : "Filtre kahve hazır olmasına kalan",
      finishAt: finish,
    };
  }
  if (b.dirtyPot && b.loadingBrewing === -1) {
    return { kind: "brewed", info: "Demlenen zaman", at: b.date };
  }
  if (!b.dirtyPot && program?.program && program.program !== "-" && program?.brewHour !== "-") {
    return {
      kind: "program",
      info: `${program.totalCupNumber} bardak ${b.type === "TEA" ? "çay" : "filtre kahve"} programı`,
      at: program.brewHour,
    };
  }
  return null;
};

/** Kirlilik oranı rengi (mobil PotInfoModal): <25 çok temiz ... */
export const dirtinessLevel = (counter, endCounter) => {
  const c = Number(counter);
  const e = Number(endCounter);
  if (!Number.isFinite(c) || !Number.isFinite(e) || e <= 0) return null;
  const pct = (c / e) * 100;
  if (pct < 25) return { label: "Çok Temiz", tone: "ok", pct };
  if (pct < 50) return { label: "Temiz", tone: "ok", pct };
  if (pct < 75) return { label: "Kirli", tone: "busy", pct };
  return { label: "Çok Kirli", tone: "danger", pct };
};

// Tabletin gönderdiği display.tone → panel tonu (StatusDisplay kategorileri).
const TABLET_TONE = {
  success: "ok",
  action: "danger",
  cancel: "busy",
  warning: "danger",
  info: "water",
  busy: "busy",
  idle: "idle",
};
export const toneFromTablet = (t) => TABLET_TONE[t] || "idle";

/**
 * Göz kartı görünümü: yeni tabletin `display`'i varsa onun metni ve tonu,
 * yoksa (eski tablet) koddan yedek tablo. Animasyon her iki durumda koddan.
 */
export const resolveCupView = (cup) => {
  const base = getCupStatus(cup?.brewingStatus);
  const d = cup?.display;
  if (!d || !d.text) return { ...base, detail: null, endsAt: null };
  return {
    ...base,
    label: d.text,
    tone: toneFromTablet(d.tone),
    showHeat: !!d.showHeat,
    detail: d.detail || null,
    endsAt: d.endsAt || null,
  };
};

const POT_LOTTIE_BY_TEXT = [
  [/Temizlik/i, "cleaning"],
  [/Su Alınıyor/i, "waterWave"],
  [/Demleniyor/i, null],
  [/Kaynama|Kazanda/i, "streakFire"],
  [/Demliği Temizleyin/i, "dirtyPot"],
  [/Servis/i, null],
];

/** Demlik görünümü: tabletin display'i varsa o, yoksa mobil kuralı. */
export const resolvePotView = (pot, lowWater, potProgramInfo, potKey) => {
  const d = pot?.display;
  if (!d || !d.text) {
    const s = getPotStatus(pot, lowWater, potProgramInfo, potKey);
    return { ...s, endsAt: null, programAt: null, programText: null, stale: !!pot?.brewInfo?.stalePot, mustClean: false, legacy: true };
  }
  const isFilter = pot?.brewInfo?.type === "FILTERCOFFEE";
  let lottie = null;
  let icon = null;
  for (const [re, name] of POT_LOTTIE_BY_TEXT) {
    if (re.test(d.text)) {
      lottie = name === null && /Demleniyor/i.test(d.text) ? (isFilter ? "filterCoffeeBrew" : "teaBrew") : name;
      break;
    }
  }
  if (!lottie) icon = d.text === "Müsait" ? "check" : isFilter ? "coffee" : "tea";
  return {
    label: d.text,
    tone: toneFromTablet(d.tone),
    lottie,
    icon,
    detail: d.detail || null,
    endsAt: d.endsAt || null,
    programAt: d.programAt || null,
    programText: d.programText || null,
    stale: !!pot?.brewInfo?.stalePot,
    mustClean: !!d.mustClean,
    productType: d.product || "",
    remain: "",
  };
};
